import { defineMessages } from 'react-intl';

const messages = defineMessages({
  connectionHeading: {
    id: 'newsftpconnection-connectionHeading',
    defaultMessage: 'connection address',
  },
  connectionSubHeading: {
    id: 'newsftpconnection-connectionSubHeading',
    defaultMessage: 'This is the address of your SFTP server.',
  },
  connectionCredentialsHeading: {
    id: 'newsftpconnection-connectionCredentialsHeading',
    defaultMessage: 'connection credentials',
  },
  connectionCredentialsSubHeading: {
    id: 'newsftpconnection-connectionCredentialsSubHeading',
    defaultMessage: 'These are the login details that provide access to your SFTP server.',
  },
  connectionCredentialsSshHint: {
    id: 'newsftpconnection-connectionCredentialsSshHint',
    /* eslint-disable */
    defaultMessage: 'SSH Public Keys can be used instead of a password to authenticate over secure protocols. Be careful, personal access tokens should be treated as securely as any other password.',
    /* eslint-enable */
  },
  connectionSSHGenerateKey: {
    id: 'newsftpconnection-connectionSSHGenerateKey',
    /* eslint-disable */
    defaultMessage: 'Copy the generated key shown below immediately. You won\'t see it again later. Otherwise, you\'ll need to generate a new one.',
  },
  connectionTransferFrequencyHeading: {
    id: 'newsftpconnection-connectionTransferFrequencyHeading',
    defaultMessage: 'transfer frequency',
  },
  connectionTransferFrequencySubHeading: {
    id: 'newsftpconnection-connectionTransferFrequencySubHeading',
    defaultMessage: 'Choose which days of the week Intersect should transfer new data to your SFTP server.',
  },
  connectionTransferFrequencyHint: {
    id: 'newsftpconnection-connectionTransferFrequencyHint',
    defaultMessage: 'File transfers will occur on selected days every week between approximately 12 AM and 1 AM.',
  },
  connectionIpWhitelistingHeading: {
    id: 'newsftpconnection-connectionIpWhitelistingHeading',
    defaultMessage: 'ip whitelisting',
  },
  connectionIpWhitelistingSubHeading: {
    id: 'newsftpconnection-connectionIpWhitelistingSubHeading',
    defaultMessage: 'To successfully accept this connection, you may need to add the Intersect Public IPs to your IP Whitelist.',
  },
  connectionFingerprintHeading: {
    id: 'newsftpconnection-connectionFingerprintHeading',
    defaultMessage: 'Server Fingerprint Verification',
  },
  connectionFingerprintSubHeading: {
    id: 'newsftpconnection-connectionFingerprintSubHeading',
    /* eslint-disable */
    defaultMessage: 'For added security, it is recommended you choose to preview and confirm the fingerprint of the SFTP server you specified. When you click "Test and Save" and this is enabled, Intersect will automatically detect and present the fingerprint to you to confirm. Once confirmed, the fingerprint will be saved as a reference and you\'ll be warned whenever changes are detected in the future.',
  },
  connectionFingerprintHint: {
    id: 'newsftpconnection-connectionFingerprintHint',
    defaultMessage: "For quicker confirmation during set up, it is recommended you ask your administrator for your server's fingerprint beforehand.",
  },
  hostValidation: {
    id: 'newsftpconnection-hostValidation',
    defaultMessage: 'Please enter a host',
  },
  portValidation: {
    id: 'newsftpconnection-portValidation',
    defaultMessage: 'Please enter a valid port between 1 and 65535',
  },
  nameValidation: {
    id: 'newsftpconnection-nameValidation',
    defaultMessage: 'Please enter a username',
  },
  passwordValidation: {
    id: 'newsftpconnection-passwordValidation',
    defaultMessage: 'Please enter a password',
  },
  sshValidation: {
    id: 'newsftpconnection-sshValidation',
    defaultMessage: 'Please generate a SSH key',
  },
  checkboxValidation: {
    id: 'newsftpconnection-checkboxValidation',
    defaultMessage: 'Please select at least 1 day',
  },
  unexpectedErrorMessageContent: {
    id: 'newsftpconnection-unexpectedErrorMessageContent',
    defaultMessage: 'The fields highlighted below need your attention',
  },
  testConnectionFailureHeading: {
    id:'newsftpconnection-testConnectionFailureMessageHeading',
    defaultMessage: 'Connection test failed',
  },
  transferFailureHeading: {
    id:'newsftpconnection-transferFailureMessageHeading',
    defaultMessage: 'File transfer failed',
  },
  fingerPrintDetectedHeading: {
    id:'newsftpconnection-fingerPrintDetectedHeading',
    defaultMessage: 'New fingerprint detected. Please take action to unblock file transfers.',
  },
  fingerPrintDetectedContentOne: {
    id:'newsftpconnection-fingerPrintDetectedContent',
    defaultMessage: 'Confirm with your administrator that this is your server\'s fingerprint:',
  },
  fingerPrintDetectedContentTwo: {
    id:'newsftpconnection-fingerPrintDetectedContentTwo',
    defaultMessage: 'If your server uses load balancing, consider disabling Server Fingerprint Verification. If you suspect malicious activity, consider editing or deleting this configuration.',
  },
  mutationFailureMessageHeading: {
    id: 'newsftpconnection-mutationFailureMessageHeading',
    defaultMessage: 'Connection couldn\'t be saved',
  },
  mutationFailureMessageContent: {
    id: 'newsftpconnection-mutationFailureMessageContent',
    defaultMessage: 'Something went wrong when attempting to save your connection. Things suggest it was a temporary glitch. Please try again.',
  },
  genericTransferFailureMessageContent: {
    id: 'newsftpconnection-TransferFailureMessageContent',
    defaultMessage: 'Connection or transfer failed. Possible reasons include a network connection interruption, insufficient SFTP server path permissions, no space on the SFTP server, attempting to transfer to a forbidden or non-existent directory, or some other scenario.'
  }
});

export default messages;
